"use client";
import Tooltip from "@/components/design-system/tooltip";
import AutoOrderDescription from "./autoOrderDescription";
import styles from "./autoOrderPopover.module.scss";

function AutoOrderPopover() {
  return (
    <Tooltip content={<AutoOrderDescription />} tailPlacement="below">
      <button type="button" className={styles.trigger}>
        Auto Order
      </button>
    </Tooltip>
  );
}

export default AutoOrderPopover;
